export async function getOrder(order_key: string) {
    console.log('get-order.ts')
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url: 'http://localhost:8000/api/v1/'};
    const endPoint = 'booking';

    let data = new FormData();
    data.append('order_key', order_key);

    return await fetch(reactAppData.api_url + endPoint, {body: data, method: 'post'})
        .then(res => res.json())
        .then(
            (result) => {
                return result
            },
            (error) => {
                return {error: error}
            }
        );
}
